import React from 'react';
import TeamBadge, { pickTeamLogo } from './TeamBadge';
import { splitGoalsByTeam } from './matchWidgetUtils';

function GoalRow({ goal, teamName }) {
  return (
    <li className="sw-goal-row">
      <span className="sw-goal-row__minute">{goal.minute}&apos;</span>
      <span className="sw-goal-row__icon" aria-hidden>
        ⚽
      </span>
      <div className="min-w-0 flex-1">
        <p className="sw-goal-row__player">{goal.player}</p>
        {goal.assist && (
          <p className="sw-goal-row__assist">Assist: {goal.assist}</p>
        )}
      </div>
      {goal.result && (
        <span className="sw-goal-row__result tabular-nums">{goal.result}</span>
      )}
      <span className="sw-goal-row__team">{teamName}</span>
    </li>
  );
}

function TeamGoalsBlock({ teamName, goals, accent, match, side }) {
  if (!goals.length) return null;
  const logoUrl = match ? pickTeamLogo(match, side) : pickTeamLogo({ team: teamName });
  return (
    <div className="sw-goals-block">
      <p className="sw-goals-block__header flex items-center gap-2" style={{ borderColor: accent }}>
        <TeamBadge name={teamName} logoUrl={logoUrl} size={18} />
        <span className="w-2 h-2 rounded-full shrink-0" style={{ background: accent }} aria-hidden />
        {teamName}
        <span className="ml-auto text-[10px] font-normal opacity-70">{goals.length}</span>
      </p>
      <ul className="space-y-1">
        {goals.map((g, i) => (
          <GoalRow key={`${g.minute}-${g.player}-${i}`} goal={g} teamName={teamName} />
        ))}
      </ul>
    </div>
  );
}

export default function MatchGoalsSection({ match, goals = [], title = 'Goals', maxPerTeam = 8 }) {
  const list = goals.length ? goals : (match?.goals || []).filter((e) => e.type === 'goal' || !e.type);
  if (!list.length) return null;

  const { home, away, homeName, awayName } = splitGoalsByTeam(list, match);

  return (
    <div className="px-4 pb-4">
      <p className="sw-section-title">{title}</p>
      <div className="space-y-3">
        <TeamGoalsBlock
          teamName={homeName}
          goals={home.slice(-maxPerTeam)}
          accent="var(--sw-accent)"
          match={match}
          side="home"
        />
        <TeamGoalsBlock
          teamName={awayName}
          goals={away.slice(-maxPerTeam)}
          accent="#3b82f6"
          match={match}
          side="away"
        />
      </div>
    </div>
  );
}
